import { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import ErrorHandler from './ErrorHandler';

import { FrontlinkProvider } from 'frontlink';
import StreamOverlay from './views/StreamOverlay/StreamOverlay';
import StreamFrame from './views/StreamFrame/StreamFrame';

const App = () => {
	const dummy = () => <span></span>;

	let { pathname } = useLocation();
	const streamKey = pathname.split('/').pop();
	const searchParams = new URLSearchParams(window.location.search);
	const features = searchParams.get('features') ?? '';

	return (
		<Suspense fallback={null}>
			<ErrorHandler>
				<Routes>
					{/* route for OBS cache-busting with an iframe redirecting to the routes below */}
					<Route path="/stream-overlay/:streamType/:streamKey" element={<StreamOverlay />} />

					<Route
						path="/stream-frame/fullscreen/:streamKey"
						element={
							<FrontlinkProvider
								api={`${import.meta.env.VITE_BACKEND_API.replace('http', 'ws')}/frontlink_stream?key=${streamKey}&src=overlay&features=${features}`}
								debugLog={/localhost|127.0.0.1/.test(window.location.hostname)}
							>
								<StreamFrame />
							</FrontlinkProvider>
						}
					/>

					{/* ensure old setups don't show anything wrong */}
					<Route path="/stream-frame/:streamType/:streamKey" element={dummy()} />
					<Route path="/stream-elements/:streamKey" element={dummy()} />
				</Routes>
			</ErrorHandler>
		</Suspense>
	);
};

export default App;
